// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Ntb69m {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  width: 113px;
  height: 108px;
  background: var(--surface-neutral-white);
  border-radius: var(--radius-s);
  box-shadow: 0 2px 12px 0 rgba(31, 31, 31, 0.06);
  padding: var(--spacing-2);
  text-decoration: none;
  transition: box-shadow 0.2s;
}

.Ntb69m:hover:not(.gUUkYy) {
  box-shadow: 0 4px 24px 0 rgba(31, 31, 31, 0.12);
}

.gUUkYy {
  cursor: default;
  pointer-events: none;
}

.gUUkYy:hover {
  box-shadow: 0 2px 12px 0 rgba(31, 31, 31, 0.06);
}

.MBJMGN {
  width: 16px;
  height: 16px;
}

.zgY2EB {
  filter: grayscale(1) brightness(1) invert(1) opacity(0.8);
}

.PjpM4Y {
  font-family: var(--font-family-base);
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-regular);
  color: var(--text-neutral-dark);
  word-break: break-word;
}

.vEjqpW {
  color: #cccccc;
}
`, "",{"version":3,"sources":["webpack://./../../packages/shared-ui/src/components/NavCard/NavCard.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,8BAA8B;EAC9B,YAAY;EACZ,aAAa;EACb,wCAAwC;EACxC,8BAA8B;EAC9B,+CAA+C;EAC/C,yBAAyB;EACzB,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yDAAyD;AAC3D;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,uCAAuC;EACvC,+BAA+B;EAC/B,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB","sourcesContent":[".card {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: space-between;\n  width: 113px;\n  height: 108px;\n  background: var(--surface-neutral-white);\n  border-radius: var(--radius-s);\n  box-shadow: 0 2px 12px 0 rgba(31, 31, 31, 0.06);\n  padding: var(--spacing-2);\n  text-decoration: none;\n  transition: box-shadow 0.2s;\n}\n\n.card:hover:not(.cardInactive) {\n  box-shadow: 0 4px 24px 0 rgba(31, 31, 31, 0.12);\n}\n\n.cardInactive {\n  cursor: default;\n  pointer-events: none;\n}\n\n.cardInactive:hover {\n  box-shadow: 0 2px 12px 0 rgba(31, 31, 31, 0.06);\n}\n\n.icon {\n  width: 16px;\n  height: 16px;\n}\n\n.iconInactive {\n  filter: grayscale(1) brightness(1) invert(1) opacity(0.8);\n}\n\n.title {\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-sm);\n  font-weight: var(--font-weight-regular);\n  color: var(--text-neutral-dark);\n  word-break: break-word;\n}\n\n.titleInactive {\n  color: #cccccc;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card": `Ntb69m`,
	"cardInactive": `gUUkYy`,
	"icon": `MBJMGN`,
	"iconInactive": `zgY2EB`,
	"title": `PjpM4Y`,
	"titleInactive": `vEjqpW`
};
module.exports = ___CSS_LOADER_EXPORT___;
